import React, { useState, useEffect, useRef } from 'react';
import gsap from 'gsap';
import Preloader from '../Components/Extras/Preloader';
import './Onboarding.css'

import LogoGreen from '../Assets/Logos/LogoGreen.svg'
import Btn from '../Components/Common/Btn';


const Onboarding = () => {
const canvasRef = useRef(null);
    const images = useRef([]);
    

    const frameCount = 141; 
    const [step, setStep] = useState(0);


    const povFrames = [0, 70, 139];
    const seqTracker = useRef({ frame: 0 });


    const render = () => {
        const canvas = canvasRef.current;
        if (!canvas) return;
        const context = canvas.getContext("2d");
        const activeFrame = Math.round(seqTracker.current.frame);
        const img = images.current[activeFrame];

        if (img && img.complete) {
            context.clearRect(0, 0, canvas.width, canvas.height);
            context.drawImage(img, 0, 0, canvas.width, canvas.height);
        }
    };

    useEffect(() => {
        for (let i = 0; i < frameCount; i++) {
            const img = new Image();
            img.src = `/sequence/HeroCar${(i + 1).toString().padStart(4, '0')}.png`;
            img.onload = () => {
                if (i === 0) render();
            };
            images.current[i] = img;
        }
    }, []);

    const handleNext = () => {
        if (step < povFrames.length - 1) {
            const nextStep = step + 1;
            setStep(nextStep);

            gsap.to(seqTracker.current, {
                frame: povFrames[nextStep],
                duration: 1.2,
                ease: "power2.inOut",
                onUpdate: render
            });

            console.log("works")
        } else {
            window.location.href = '/login';
        }
    };


    const onboardData = [
    {
        title: "Book Your Visit",
        sub: "Explore the latest EV technology and innovations at Egypt's premier electric vehicle exhibition.",
    },
    {
        title: "Discover Electric Vehicles",
        sub: "Reserve your spot for exclusive events, test drives, and expert presentations.",
    },
    {
        title: "Find Charging Solutions",
        sub: "Explore the latest EV technology and innovations at Egypt's premier electric vehicle exhibition.",
    }
];
    
    return ( <>
        <Preloader />
        <main className='Onboarding'>
            <div className='BGAnim'>
                <canvas ref={canvasRef} width={1920} height={1080} className='BgImg' />
            </div>

            <section className='OnboardScreens'>
                <div className='OBScreen'>
                    <img className='LogoGreen' src={LogoGreen} alt="" />

                    <div className='OBContent'>
                        <p className='OBTitle'>
                            {onboardData[step].title}
                        </p>
                        <p className='OBSub'>
                            {onboardData[step].sub}
                        </p>

                        <div className='OBBtns'>
                            <Btn 
                                BtnStyle='HollowBtn' 
                                BtnText='Skip' 
                                onClick={() => window.location.href = '/login'} 
                            />
                            <Btn 
                                onClick={handleNext} 
                                BtnStyle='GreenBtn' 
                                BtnText={step === onboardData.length - 1 ? 'Get Started' : 'Next'}
                            />
                        </div>
                    </div>
                </div>
            </section>
        </main>
    </> );
}
 
export default Onboarding;